import React from 'react';
import { connect } from 'react-redux';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { AUTH_PROFILE_UPDATE_LEGACY_INFO, AUTH_SEND } from 'apps/auth/constants/UrlConstants';
import { CANADA, ISRAEL, USA } from 'apps/auth/constants/WellKnownCountries';

const TermsUpdatePopup = (props) => {
    const getHeader = (userCountryId) => {
        if (userCountryId === USA || userCountryId === CANADA) {
            return props.termsModalTextSpecial;
        } else if (userCountryId === ISRAEL) {
            return props.israelTermsModalText;
        }

        return props.termsModalText;
    };

    return (
        <SimplePopup popupRef={props.popupRef} text={getHeader(props.countryId)} withoutBorder={false}>
            <PopupButton
                text={props.termsModalSubmit}
                iconName="arrow-forward"
                href={AUTH_PROFILE_UPDATE_LEGACY_INFO + `?newTerms=true&redirectUrl=${props.redirectUrl}${props.backUrl ? '&backUrl=' + props.backUrl : ''}`}
            />
        </SimplePopup>
    );
};

TermsUpdatePopup.defaultProps = {
    redirectUrl: AUTH_SEND,
};

const mapStateToProps = (state) => {
    return {
        countryId: state.auth.countryId,
        termsModalTextSpecial: state.messages.pageMessages.termsModalTextSpecial,
        israelTermsModalText: state.messages.pageMessages.israelTermsModalText,
        termsModalText: state.messages.pageMessages.termsModalText,
        termsModalSubmit: state.messages.pageMessages.termsModalSubmit,
    };
};
export default connect(mapStateToProps)(TermsUpdatePopup);
